module.exports = __webpack_public_path__ + "img/ai_flag.8928b702.svg";